var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.515 3.515c4.686-4.686 12.284-4.686 16.97 0C22.735 5.765 24 8.818 24 12.001c0 3.182-1.264 6.235-3.515 8.485-4.686 4.686-12.284 4.686-16.97 0-4.687-4.687-4.687-12.284 0-16.97zM19.07 4.93c-3.928-3.85-10.214-3.85-14.142 0-3.9 3.908-3.9 10.235 0 14.143 3.932 3.84 10.21 3.84 14.142 0 3.799-3.949 3.799-10.194 0-14.143zm-.618 2.515c.076.006.144.046.188.108 2.13 3.17 1.72 7.405-.98 10.106-2.701 2.7-6.936 3.112-10.106.982-.062-.043-.102-.112-.11-.188-.006-.075.02-.15.074-.204l10.73-10.731c.054-.053.129-.08.204-.073zM6.547 6.149c2.704-2.526 6.809-2.868 9.9-.79.062.044.102.112.108.188.007.076-.02.15-.074.204L5.756 16.479c-.054.053-.13.08-.205.073-.076-.007-.144-.047-.188-.109-2.12-3.171-1.709-7.398.984-10.1z",
    transform: "translate(-1126 -264) translate(1126 264)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.d6528372.svg";
export { ForwardRef as ReactComponent };